import { every, filter, map } from 'lodash';

export const CHANGE_SELECTED_TASKS = 'CHANGE_SELECTED_TASKS';
export function changeSelectedTasks(tasks) {
  return {
    type: CHANGE_SELECTED_TASKS,
    tasks: tasks
  };
}

export function toggleSelectTask(task) {
  return (dispatch, getState) => {

    const selectedTaskIds = getState().selectList.selectedTaskIds || [];
    let newSelected;

    if (selectedTaskIds.indexOf(task.id) > -1) {
      newSelected = filter(selectedTaskIds, id => id !== task.id);
    } else {
      newSelected = [...selectedTaskIds, task.id];
    }
    dispatch(changeSelectedTasks(newSelected));
  };
}

export function toggleSelectAllTasks() {
  return (dispatch, getState) => {
    const tasks = getState().search.tasks;
    const selectedTaskIds = getState().selectList.selectedTaskIds || [];

    const allSelected = every(
      tasks, task => selectedTaskIds.indexOf(task.id) > -1
    );
    if (allSelected) {
      dispatch(changeSelectedTasks([]));
    } else {
      dispatch(changeSelectedTasks(map(tasks, task => task.id)));
    }
  };
}
